<div class="discussion-page tanuh-themed-page">
  <app-header></app-header>

  <div class="discussion-page--content">
    <app-asset-header [config]="headerConfig" variant="tanuh"></app-asset-header>

    <div class="discussion-page--main">
      <div class="discussion-page--container">
        <aside class="discussion-page--sidebar">
          <button 
            class="discussion-page--new-discussion-btn"
            type="button"
            (click)="createNewDiscussion()"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            New Discussion
          </button>
          <app-discussion-sidebar [activeTab]="activeTab"></app-discussion-sidebar>
        </aside>

        <main class="discussion-page--main-content">
          <div class="discussion-content">
            <div class="discussion-content--header">
              <div class="discussion-content--title-wrapper">
                <div class="discussion-content--title-row">
                  <h2 class="discussion-content--title">My Discussions</h2>
                </div>
                <p class="discussion-content--description">
                  View and manage all discussions you have created. Track your contributions and engage with responses from the community.
                </p>
              </div>
            </div>

            <app-discussion-list
              [discussions]="discussions"
              [isLoggedIn]="isLoggedIn"
              [categoryName]="'My Discussions'"
              [showDeleteForOwner]="true"
              (bookmarkClick)="onBookmarkClick($event)"
              (pinClick)="onPinClick($event)"
              (editClick)="onEditClick($event)"
              (deleteClick)="onDeleteClick($event)"
            ></app-discussion-list>
          </div>
        </main>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <app-login-modal [(visible)]="showLoginModal"></app-login-modal>

  <app-confirmation-dialog
    [(visible)]="showDeleteConfirmModal"
    type="delete"
    themeColor="red"
    title="Delete Discussion"
    [message]="discussionToDelete ? 'Are you sure you want to delete &quot;' + (discussionToDelete.title || 'this discussion') + '&quot;? This action cannot be undone.' : ''"
    confirmLabel="Delete"
    cancelLabel="Cancel"
    [loading]="deleteInProgress"
    (onConfirm)="onConfirmDelete()"
    (onCancel)="onCancelDelete()"
  ></app-confirmation-dialog>
</div>
